import { Typography } from '@zeptonow/zui';
import { generateImage } from '../utils/generateImage';

const UnauthorisedAccess = () => {
  return (
    <div className="flex flex-col justify-center items-center h-[calc(100vh-4rem)]">
      {generateImage({
        noScale: true,
        name: 'locked-computer',
        extension: 'png',
        alt: 'Unauthorised icon',
        className: 'h-[13.375rem] w-[13.375rem]',
      })}
      <div className="w-[22rem] text-center ">
        <Typography className="h-6 !mb-1 !text-gray-900">
          Access Restricted
        </Typography>
        <Typography className="h-5 !text-sm !text-gray-500">
          You don't have access to this module.
        </Typography>
      </div>
    </div>
  );
};
export default UnauthorisedAccess;
